import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import contratoService from "services/ContratoService";
import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import comboService from "services/ComboService";
import ModalHistoricoLogs from "components/ModalHistoricoLogs";

export default function Contratos() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [fiscais, setFiscais] = useState([])
  const [gestores, setGestores] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [consorcios, setConsorcios] = useState([])
  const [termo, setTermo] = useState(null)
  const [idFiscal, setIdFiscal] = useState(null)
  const [idGestor, setIdGestor] = useState(null)
  const [idEmpresa, setIdEmpresa] = useState(null)
  const [idConsorcio, setIdConsorcio] = useState(null)
  const [idStatus, setIdStatus] = useState(null)
  const [items, setItems] = useState([])
  const [exibirInativos, setExibirInativos] = useState(false)
  const [totalInativos, setTotalInativos] = useState(0)
  const navigate = useNavigate()
  const [modalLogContrato, setModalLogContrato] = useState({ isOpen: false, idRegistro: null, titulo: '' })

  const carregar = async () => {
    const res = await contratoService.get(termo, idFiscal, idGestor, idEmpresa, idConsorcio, idStatus, pagina, exibirInativos)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
      setTotalInativos(res.data.totalInativos ?? 0)
    }
  }

  useEffect(() => {
    comboService.fiscal().then(res => {
      if (res.success) {
        setFiscais(res.data)
      } else {
        setFiscais([])
      }
    })
    comboService.gestorContrato().then(res => {
      if (res.success) {
        setGestores(res.data)
      } else {
        setGestores([])
      }
    })
    comboService.empresa().then(res => {
      if (res.success) {
        setEmpresas(res.data)
      } else {
        setEmpresas([])
      }
    })
    comboService.consorcio().then(res => {
      if (res.success) {
        setConsorcios(res.data)
      } else {
        setConsorcios([])
      }
    })
  }, [])

  useEffect(() => {
    carregar()
  }, [pagina, exibirInativos])

  const handleDelete = (item) => {
    confirm({
      header: "Cancelamento",
      text: "Tem certeza que deseja cancelar este contrato?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await contratoService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Contrato cancelado")
          } else {
            toast("Erro ao cancelar o contrato")
          }
        } catch (ex) {
          toast("Erro ao cancelar o contrato")
        }
      }
    })
  }

  const handleRestore = (item) => {
    confirm({
      header: "Restauração",
      text: "Tem certeza que deseja restaurar este contrato?",
      icon: "bi-arrow-counterclockwise",
      onConfirm: async () => {
        try {
          const res = await contratoService.restaurar(item.id)
          if (res.success) {
            carregar()
            toast("Contrato restaurado")
          } else {
            toast("Erro ao restaurar o contrato")
          }
        } catch (ex) {
          toast(ex?.response?.data?.message || "Erro ao restaurar o contrato")
        }
      }
    })
  }

  const abrirLogContrato = (contrato) => {
    setModalLogContrato({
      isOpen: true,
      idRegistro: contrato.id,
      titulo: `LOG do contrato ${contrato.numero}`,
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Contratos</h1>
          <Link className="btn btn-primary btn-icon" to="/admin/contratos/0">Incluir</Link>
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Número</Label>
                    <Input type="text" placeholder="Número" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Fiscal</Label>
                    <select className="form-control" value={idFiscal || ''} onChange={e => setIdFiscal(e.target.value)}>
                      <option value="">Todos</option>
                      {fiscais.map(el => (
                        <option key={el.id} value={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Gestor</Label>
                    <select className="form-control" value={idGestor || ''} onChange={e => setIdGestor(e.target.value)}>
                      <option value="">Todos</option>
                      {gestores.map(el => (
                        <option key={el.id} value={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <FormGroup>
                    <Label>Empresa</Label>
                    <select className="form-control" value={idEmpresa || ''} onChange={e => setIdEmpresa(e.target.value ? +e.target.value : null)}>
                      <option value="">Todas</option>
                      {empresas.map(el => (
                        <option key={el.id} value={el.id}>{el.razaoSocial}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Consórcio</Label>
                    <select className="form-control" value={idConsorcio || ''} onChange={e => setIdConsorcio(e.target.value ? +e.target.value : null)}>
                      <option value="">Todas</option>
                      {consorcios.map(el => (
                        <option key={el.id} value={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Status</Label>
                    <select className="form-control" value={idStatus || ''} onChange={e => setIdStatus(e.target.value ? e.target.value : null)}>
                      <option value="">Todas</option>
                      <option value="R">Rascunho</option>
                      <option value="P">Publicado</option>
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {totalInativos > 0 && (
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="text-muted small mr-3">
              {exibirInativos
                ? `Exibindo ${totalInativos} contrato(s) cancelado(s)`
                : `Ocultando ${totalInativos} contrato(s) cancelado(s)`}
            </div>
            <div className="d-flex align-items-center mb-0 gap-5px">
              <div>Exibir cancelados</div>
              <label className="custom-toggle" style={{ marginBottom: 0 }}>
                <input
                  type="checkbox"
                  id="exibirInativosContratos"
                  checked={exibirInativos}
                  onChange={e => { setExibirInativos(e.target.checked); setPagina(1) }}
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
            </div>
          </div>
        )}

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Número</th>
                <th scope="col">Fiscal</th>
                <th scope="col">Gestor</th>
                <th scope="col">Empresa</th>
                <th scope="col">Status</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={5} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id} className={!el.ativo ? 'text-muted' : ''}>
                  <td>
                    {el.numero}
                    {!el.ativo && <span className="badge badge-danger ml-2">Cancelado</span>}
                  </td>
                  <td>{el.fiscal}</td>
                  <td>{el.gestor}</td>
                  <td>{el.consorcioEmpresa == 'E' ? el.empresa : el.consorcio}</td>
                  <td>{el.statusFmt}</td>
                  <td className="d-flex flex-row gap-5px">
                    {el.ativo && el.idStatus === 'R' && <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/contratos/" + el.id)} />}
                    {el.ativo && el.idStatus !== 'R' && <IconButton alt="Visualizar/Acessar" iconClass="bi-eye" onClick={() => navigate("/admin/contratos/" + el.id)} />}
                    {el.ativo && el.idStatus === 'R' && <IconButton alt="Cancelar" iconClass="bi-x-circle" onClick={() => handleDelete(el)} />}
                    {!el.ativo && el.idStatus === 'R' && <IconButton alt="Restaurar" iconClass="bi-arrow-counterclockwise" onClick={() => handleRestore(el)} />}
                    <IconButton alt="Histórico" iconClass="bi-card-list" onClick={() => navigate(`/admin/contratos/${el.id}/historico`)} />
                    <IconButton alt="LOG" iconClass="bi-clock-history" onClick={() => abrirLogContrato(el)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
        <ModalHistoricoLogs
          isOpen={modalLogContrato.isOpen}
          toggle={() => setModalLogContrato({ isOpen: false, idRegistro: null, titulo: '' })}
          tipo="contrato"
          idRegistro={modalLogContrato.idRegistro}
          titulo={modalLogContrato.titulo || 'LOG do contrato'}
        />
      </Container>
    </>
  )
}